<ion-header>
	<app-account-toolbar
		src="../../../assets/dean_and_david/burger-menu/registration.svg"
		title="account.title"
		(back)="goBack()"
	></app-account-toolbar>
</ion-header>
<div class="main-content" style="height: 100%; overflow: auto">
	<div class="main-content-wrapper">
		<div>
			<ion-row *ngIf="!loading" class="ion-justify-content-center" role="region" aria-label="Content center row">
				<ion-col
					class="ion-padding ion-margin-top wrapper"
					size="12"
					size-lg="4"
					size-md="6"
					*ngIf="userDataForm"
					[formGroup]="userDataForm"
				>
					<div class="error_container" role="region" aria-label="Error message container">
						<ion-note class="input-error" [class.visible]="isValid('gender')" slot="error"
							>{{ 'sign_up.validation.gender' | translate }}
						</ion-note>
					</div>

					<ion-label class="stacked">{{ 'sign_up.name' | translate }}*</ion-label>
					<ion-item
						class="input ion-invalid"
						lines="none"
						[class.ion-info]="!isValid('fullName') && isValidByPattern('fullName')"
					>
						<ion-input formControlName="fullName" name="name" type="text"></ion-input>
					</ion-item>
					<div class="error_container" role="region" aria-label="Error container">
						<ion-note class="input-error" [class.visible]="isValid('fullName')" slot="error"
							>{{ 'sign_in.required' | translate }}
						</ion-note>
						<ion-note class="input_info" [class.visible]="!isValid('fullName') && isValidByPattern('fullName')" slot="error"
							>{{ 'sign_up.validation.name' | translate }}
						</ion-note>
					</div>

					<div class="custom_phone container" role="region" aria-label="Custom phone container">
						<ion-label class="stacked">{{ 'checkout_modal.phone' | translate }} {{ 'sign_up.optional'|translate }} </ion-label>
						<ion-item
							class="ion-invalid item_input"
							lines="none"
							[class.ion-info]="!isValid('phone') && isValidByPattern('phone')"
						>
							<app-input-phone-with-county-code
								formControlName="phone"
								[hasBackground]="false"
							></app-input-phone-with-county-code>
						</ion-item>
						<div class="error_container" role="region" aria-label="Error container">
							<ion-note class="input-error" [class.visible]="isValid('phone')" slot="error"
								>{{ 'sign_up.validation.required' | translate }}
							</ion-note>
							<ion-note
								class="input_info"
								[class.visible]="
							!isValid('phone') && getErrorsForm('phone')?.invalidPhone && userDataForm.get('phone')?.dirty
						"
								slot="error"
								>{{ 'errors.phone' | translate }}
							</ion-note>
						</div>
					</div>
					<div class="container">
						<ion-label>{{ 'sign_up.birthday' | translate }} {{ 'sign_up.optional' | translate }}</ion-label>
						<ion-item
							class="input input-age"
							lines="none"
							[class.ion-info]="!isValid('fullName')
					&&
					isValidByPattern('fullName')"
						>
							<ion-input
								formControlName="day"
								placeholder="DD"
								type="tel"
								maxlength="2"
								#field1
								(keyup)="(field1.value.toString().length == 2) ?
						gotoNextField(field2): ''"
							></ion-input>
							<ion-input
								formControlName="month"
								type="tel"
								maxlength="2"
								placeholder="MM"
								#field2
								(keyup)="(field2.value.toString().length == 2)
						?
						gotoNextField(field3): ''"
							></ion-input>
							<ion-input formControlName="year" type="tel" maxlength="4" placeholder="YYYY" #field3></ion-input>
						</ion-item>
						<div class="error_container" role="region" aria-label="Error message container">
							<ion-note class="input-error" [class.visible]="isValid('day')" slot="error"
								>{{ 'sign_up.validation.required' | translate }}
							</ion-note>
							<ion-note class="input-error" [class.visible]="isValid('month')" slot="error"
								>{{ 'sign_up.validation.required' | translate }}
							</ion-note>
							<ion-note class="input-error" [class.visible]="isValid('year')" slot="error"
								>{{ 'sign_up.validation.required' | translate }}
							</ion-note>
							<ion-note
								class="input_info"
								[class.visible]="!isValid('day') &&
						isValidByPattern('day')"
								slot="error"
								>{{ 'sign_up.validation.date' | translate }}
							</ion-note>
							<ion-note
								class="input_info"
								[class.visible]="!isValid('month') &&
						isValidByPattern('month')"
								slot="error"
								>{{ 'sign_up.validation.month' | translate }}
							</ion-note>
							<ion-note
								class="input_info"
								[class.visible]="!isValid('year') &&
						isValidByPattern('year')"
								slot="error"
								>{{ 'sign_up.validation.year' | translate }}
							</ion-note>
						</div>
					</div>
				</ion-col>
			</ion-row>
			<ion-row
				*ngIf="loading || !userDataForm"
				class="ion-justify-content-center block loading"
				role="region"
				aria-label="Loading content"
			>
				<ion-spinner color="primary"></ion-spinner>
			</ion-row>
			<div>
				<ion-row role="region" aria-label="Account section">
					<ion-col size="12" class="delete-section">
						<ion-button (click)="deleteAccount()">{{ 'account.delete'| translate }}</ion-button>
					</ion-col>
				</ion-row>
				<ion-row class="ion-justify-content-center">
					<ion-col class="ion-padding" size="12" size-lg="4" size-md="6">
						<ion-button (click)="update()" [disabled]="!isValid() || loading" expand="block"
							>{{ 'account.save' | translate }} {{userDataForm.errors}}
						</ion-button>
					</ion-col>
				</ion-row>
			</div>
		</div>
	</div>
</div>
